import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { getUrl } from "./urls";
import { getAccessToken, getCompanyId } from "./utils";
import { getInterval, getMetricsValue } from "./insightsActionUtils";

export const FETCH_LINKEDIN_PAGE_LIST = "FETCH_LINKEDIN_PAGE_LIST";
export const SET_LINKEDIN_SELECTED_PAGE = "SET_LINKEDIN_SELECTED_PAGE";
export const UPDATE_LINKEDIN_DURATION_FILTER = "UPDATE_LINKEDIN_DURATION_FILTER";
export const FETCH_LK_METRICS_PENDING = "FETCH_LK_METRICS_PENDING";
export const FETCH_LK_METRICS_FULFILLED = "FETCH_LK_METRICS_FULFILLED";
export const FETCH_LK_METRICS_REJECTED = "FETCH_LK_METRICS_REJECTED";
export const FETCH_LK_METRICS = "FETCH_LK_METRICS";
export const FETCH_LK_PAGE_FOLLOWERS = "FETCH_LK_PAGE_FOLLOWERS";
export const FETCH_LK_FOLLOWERS_BY_FACET = "FETCH_LK_FOLLOWERS_BY_FACET";
export const FETCH_LK_FOLLOWERS_BY_FACET_PENDING = "FETCH_LK_FOLLOWERS_BY_FACET_PENDING";
export const FETCH_LK_FOLLOWERS_BY_FACET_FULFILLED = "FETCH_LK_FOLLOWERS_BY_FACET_FULFILLED";
export const FETCH_LK_FOLLOWERS_BY_FACET_REJECTED = "FETCH_LK_FOLLOWERS_BY_FACET_REJECTED";

export function fetchLinkedinPagesList() {
    let page_details = [];
    let res = axios({
        method: "get",
        url: getUrl("social_token_list"),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            response.data.data.tokens.map((k, v) => {
                // console.log("chck page instagram linkedin", k.platform);
                if (k.platform === "linkedin" && k.insight_feature === 1) {
                    page_details.push(k);
                }
            });
            return page_details;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_LINKEDIN_PAGE_LIST",
        payload: res,
    };
}

export function setSelectedPage(value) {
    return {
        type: "SET_LINKEDIN_SELECTED_PAGE",
        payload: value,
    };
}

export function updateDurationFilter(value) {
    return {
        type: "UPDATE_LINKEDIN_DURATION_FILTER",
        payload: value,
    };
}

export const fetchAllLKPostDetails = (data) => {
    let params = new URLSearchParams();
    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("apply_exclusion", "no");
    // params.append("post_type", "0");
    params.append("platform", ["b58cda8d-c22d-11e8-b7dd-02eebbc40807"]);
    params.append("custom_query", `handlers:"${data.handler}"`);
    // params.append("custom_query", `handlers:"hero-vired"`);
    params.append("post_type", "0");

    switch (data.name) {
        case "total-reach":
            params.append("aggs-interval", "year");
            params.append("aggs", "total_estimated_reach");
            break;

        case "total_engagement":
            params.append("aggs-interval", "year");
            params.append("aggs", "like-count-stats,share-count-stats,comment-count-stats,view-count-stats");
            break;

        case "total-posts":
            // params.append("aggs-interval", "year");
            break;

        case "total-posts-likes":
            params.append("aggs-interval", "year");
            params.append("aggs", "like-count-stats");
            break;

        case "total-posts-comments":
            params.append("aggs-interval", "year");
            params.append("aggs", "comment-count-stats");
            break;

        case "total-posts-impressions":
            params.append("aggs-interval", "year");
            params.append("aggs", "view-count-stats");
            break;

        case "total-posts-shares":
            params.append("aggs-interval", "year");
            params.append("aggs", "share-count-stats");
            break;

        default:
            break;
    }

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

export const upperChartsInsightsApi = (data) => {
    const metrics = getMetricsValue(data.name);

    return axios.get(
        `${getUrl("linkedin_insight_service")}/get-insight?page_id=${data.page_id}&metrics=${metrics}&start_date=${data.start_date}&end_date=${
            data.end_date
        }&agreegate_interval=yearly`,
        {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "access-token": getAccessToken(),
            },
        },
    );
};
export const totalFollowersData = (params) => {
    return axios.get(
        getUrl("linkedin_followers") + `?start_date=${params.start_date}&end_date=${params.end_date}&page_id=${params.page_id}&agreegate_interval=yearly`,
        {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "access-token": getAccessToken(),
            },
        },
    );
};
export const fetchDataFromLinkedin = (ApiCall, data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_LK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let presentDurationData = ApiCall(data).then((res) => ({ name: "presentDurationData", data: res.data }));
        let data2 = { ...data };
        let durationGap = moment(data.end_date).diff(moment(data.start_date), "days", true);
        data2["start_date"] = moment(data.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        data2["end_date"] = moment(data.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let previousDurationData = ApiCall(data2).then((res) => ({ name: "previousDurationData", data: res.data }));

        Promise.all([presentDurationData, previousDurationData])
            .then((response) => {
                // console.log("checkkkk", chartName, response);
                dispatch({
                    type: "FETCH_LK_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response,
                        durationGap,
                    },
                });
                return response;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_LK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export function fetchLKChartMetrics(params) {
    const chartName = params["name"];
    delete params["name"];

    return function (dispatch) {
        // if (params?.isAverage) dispatch(fetchAverageIgMetrics(params, chartName));
        dispatch({
            type: "FETCH_LK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let resp = axios({
            method: "post",
            url: getUrl("searchaggs"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_LK_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res.data },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_LK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
}

export const fetchLKRecentPostsData = (dispatch, params, chartName) => {
    dispatch({
        type: "FETCH_LK_METRICS_PENDING",
        payload: { chart_name: chartName },
    });
    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_LK_METRICS_FULFILLED",
                payload: { chart_name: chartName, response: response.data?.hits?.hits },
            });
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: "FETCH_LK_METRICS_REJECTED",
                payload: { chart_name: chartName },
            });
        });
};

export const fetchLKFollowersCount = (params) => {
    const chartName = params["name"];
    const interval = getInterval(params.agreegate_interval);

    return (dispatch) => {
        dispatch({
            type: "FETCH_LK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let res = axios
            .get(
                getUrl("linkedin_followers") +
                    `?start_date=${params.start_date}&end_date=${params.end_date}&page_id=${params.page_id}&agreegate_interval=${interval}`,
                {
                    cache: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        "access-token": getAccessToken(),
                    },
                },
            )
            .then((response) => {
                dispatch({
                    type: "FETCH_LK_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: response.data?.data },
                });
            })
            .catch((error) => {
                console.log(error);

                dispatch({
                    type: "FETCH_LK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const fetchLKInsightsData = (data) => {
    const chartName = data["name"];
    const interval = getInterval(data.agreegate_interval);

    return (dispatch) => {
        dispatch({
            type: "FETCH_LK_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let res = axios
            .get(
                `${getUrl("linkedin_insight_service")}/get-insight?page_id=${data.page_id}&metrics=${data.aggs_value}&start_date=${data.start_date}&end_date=${
                    data.end_date
                }&agreegate_interval=${interval}`,
                {
                    cache: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        "access-token": getAccessToken(),
                    },
                },
            )
            .then((response) => {
                dispatch({
                    type: "FETCH_LK_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: response.data?.data },
                });
            })
            .catch((error) => {
                console.log(error);

                dispatch({
                    type: "FETCH_LK_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const fetchLKFollowersFacet = (pageId) => {
    // const chartName = data["name"];
    // const interval = getInterval(data.agreegate_interval);
    // 2868212
    return (dispatch) => {
        dispatch({
            type: "FETCH_LK_FOLLOWERS_BY_FACET_PENDING",
            // payload: { chart_name: chartName },
            payload: { pageId },
        });
        let res = axios
            .get(getUrl("linkedin_followers_by_facet") + `?page_id=${pageId}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "access-token": getAccessToken(),
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_LK_FOLLOWERS_BY_FACET_FULFILLED",
                    payload: { chart_name: "followersCountByFacets", response: response.data?.data },
                });
            })
            .catch((error) => {
                console.log(error);

                dispatch({
                    type: "FETCH_LK_FOLLOWERS_BY_FACET_REJECTED",
                    // payload: { chart_name: chartName },
                    payload: { pageId },
                });
            });
    };
};
